import { lazy } from 'react';

export const Documentation = lazy(() =>
  import('./index').then(module => ({ default: module.Documentation })),
);
